<script>
    const classes = {
        1: 'heading',
        2: 'heading text-xl',
        3: 'heading text-lg',
    };

    export default {
        props: {
            level: {
                default: 1,
                type: Number,
            },
        },

        render(h) {
            return h(`h${this.level}`, { class: classes[this.level] }, this.$slots.default);
        },
    };
</script>
